import i18next from 'i18next';
import { CUSTOM_TAGS_OPTIONS } from '../Shared/CustomTags';
import FILTER_TYPES from '../Shared/Table/widgets/Filters/constants';

export const ACCOUNT_TYPES = {
  STANDARD: 'standard',
  DISTRIBUTION_SPONSOR: 'distributionSponsor',
};

// Account Form Tab Names
export const ACCOUNT_TABS = {
  BASIC_INFORMATION: 'BASIC_INFORMATION',
  ADDRESSES: 'ADDRESSES',
  FEATURES: 'FEATURES',
  SETTINGS: 'SETTINGS',
  INSTANT_ASSESSMENTS: 'INSTANT_ASSESSMENTS',
};

// Tab display labels
export const ACCOUNT_TAB_LABELS = {
  [ACCOUNT_TABS.BASIC_INFORMATION]: 'BASIC INFORMATION',
  [ACCOUNT_TABS.ADDRESSES]: 'ADDRESSES',
  [ACCOUNT_TABS.FEATURES]: 'FEATURES',
  [ACCOUNT_TABS.SETTINGS]: 'SETTINGS',
  [ACCOUNT_TABS.INSTANT_ASSESSMENTS]: 'INSTANT ASSESSMENTS',
};

export const STATES = [
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
  { label: 'District of Columbia', value: 'DC' },
];

export const CLAIM_REPORT_TYPES = [
  { label: 'Without financial information', value: 'templateA' },
  { label: 'With financial information', value: 'templateB' },
];

export const ACCOUNT_COLUMNS = [
  {
    size: 200,
    header: i18next.t('tables:customTags'),
    accessorKey: 'customTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
  },
  {
    size: 300,
    header: i18next.t('tables:name'),
    accessorKey: 'businessName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 180,
    header: i18next.t('tables:customId'),
    accessorKey: 'customIdentifier',
    enableHiding: false,
    filter: {},
    isDefaultCell: true,
  },
  {
    size: 300,
    header: i18next.t('tables:address'),
    accessorKey: 'address',
    filter: {},
    isDefaultCell: true,
  },
];
